// extracted by mini-css-extract-plugin
export var skeletonLoader = "b5_hJ";
export var skeletonWrapper = "b5_hH";